import React, { useState, useEffect } from 'react'
import Layout from '../components/Layout'
import api from '../services/api'

export default function DivisionsPage() {
  const [divisions, setDivisions] = useState([])
  const [loading, setLoading] = useState(true)
  const [showModal, setShowModal] = useState(false)
  const [editData, setEditData] = useState(null)
  const [form, setForm] = useState({ name: '', code: '', level: 'กอง' })
  const [error, setError] = useState('')
  const [saving, setSaving] = useState(false)

  useEffect(() => { fetchDivisions() }, [])

  const fetchDivisions = async () => {
    try {
      setLoading(true)
      const res = await api.get('/divisions')
      if (res.data.success) setDivisions(res.data.data)
    } catch (err) { console.error(err) }
    finally { setLoading(false) }
  }

  const openAddModal = () => {
    setEditData(null)
    setForm({ name: '', code: '', level: 'กอง' })
    setError('')
    setShowModal(true)
  }

  const openEditModal = (div) => {
    setEditData(div)
    setForm({ name: div.name, code: div.code || '', level: div.level || 'กอง' })
    setError('')
    setShowModal(true)
  }

  const handleSave = async () => {
    setError('')
    if (!form.name) { setError('กรุณากรอกชื่อกองงาน'); return }
    try {
      setSaving(true)
      if (editData) await api.put(`/divisions/${editData.id}`, form)
      else await api.post('/divisions', form)
      setShowModal(false)
      fetchDivisions()
    } catch (err) { setError(err.response?.data?.message || 'เกิดข้อผิดพลาด') }
    finally { setSaving(false) }
  }

  const levelConfig = {
    'สำนัก': { color: '#3b82f6', bg: '#eff6ff' },
    'กอง':   { color: '#8b5cf6', bg: '#f5f3ff' },
    'ฝ่าย':  { color: '#22c55e', bg: '#f0fdf4' },
  }

  const inputStyle = { width: '100%', padding: '9px 12px', border: '0.5px solid #e2e8f0', borderRadius: '9px', fontSize: '13px', color: '#0f172a', background: 'white', outline: 'none', fontFamily: 'inherit' }
  const labelStyle = { display: 'block', fontSize: '12px', color: '#374151', marginBottom: '5px' }

  return (
    <Layout>
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>

        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '24px' }}>
          <div>
            <h1 style={{ fontSize: '20px', fontWeight: '500', color: '#0f172a' }}>จัดการกองงาน</h1>
            <p style={{ fontSize: '13px', color: '#94a3b8', marginTop: '4px' }}>กองงานทั้งหมดในเทศบาล</p>
          </div>
          <button onClick={openAddModal}
            style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '9px 18px', background: '#075dcc', color: 'white', border: 'none', borderRadius: '10px', fontSize: '13px', fontWeight: '500', cursor: 'pointer' }}>
            <i className="ti ti-plus" style={{ fontSize: '16px' }} />
            เพิ่มกองงาน
          </button>
        </div>

        {/* Table */}
        <div style={{ background: 'white', borderRadius: '14px', border: '0.5px solid #e2e8f0', overflow: 'hidden' }}>
          {loading ? (
            <div style={{ textAlign: 'center', padding: '60px', color: '#94a3b8', fontSize: '13px' }}>กำลังโหลด...</div>
          ) : divisions.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '60px', color: '#94a3b8', fontSize: '13px' }}>ไม่พบข้อมูลกองงาน</div>
          ) : (
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ background: '#f8fafc' }}>
                    {['ชื่อกองงาน', 'รหัส', 'ระดับ', 'จัดการ'].map(h => (
                      <th key={h} style={{ textAlign: 'left', padding: '10px 20px', fontSize: '11px', color: '#94a3b8', fontWeight: '500' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {divisions.map(div => {
                    const lc = levelConfig[div.level] || { color: '#64748b', bg: '#f1f5f9' }
                    return (
                      <tr key={div.id} style={{ borderTop: '0.5px solid #f1f5f9' }}
                        onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'}
                        onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                        <td style={{ padding: '12px 20px', fontSize: '13px', fontWeight: '500', color: '#0f172a' }}>{div.name}</td>
                        <td style={{ padding: '12px 20px', fontSize: '12px', color: '#94a3b8' }}>{div.code || '-'}</td>
                        <td style={{ padding: '12px 20px' }}>
                          <span style={{ display: 'inline-flex', padding: '3px 10px', borderRadius: '999px', fontSize: '11px', fontWeight: '500', color: lc.color, background: lc.bg }}>{div.level || '-'}</span>
                        </td>
                        <td style={{ padding: '12px 20px' }}>
                          <button onClick={() => openEditModal(div)}
                            style={{ padding: '4px 10px', background: '#eff6ff', color: '#075dcc', border: 'none', borderRadius: '6px', fontSize: '11px', cursor: 'pointer' }}>แก้ไข</button>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50, padding: '16px' }}>
          <div style={{ background: 'white', borderRadius: '16px', width: '100%', maxWidth: '420px' }}>
            <div style={{ padding: '20px 24px', borderBottom: '0.5px solid #f1f5f9', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <p style={{ fontSize: '15px', fontWeight: '500', color: '#0f172a' }}>{editData ? 'แก้ไขกองงาน' : 'เพิ่มกองงานใหม่'}</p>
              <button onClick={() => setShowModal(false)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#94a3b8', fontSize: '20px' }}>×</button>
            </div>
            <div style={{ padding: '20px 24px' }}>
              {error && (
                <div style={{ background: '#fef2f2', border: '0.5px solid #fecaca', color: '#ef4444', borderRadius: '8px', padding: '10px 14px', marginBottom: '16px', fontSize: '13px' }}>{error}</div>
              )}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
                <div>
                  <label style={labelStyle}>ชื่อกองงาน</label>
                  <input type="text" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="เช่น กองการศึกษา" style={inputStyle} />
                </div>
                <div>
                  <label style={labelStyle}>รหัสกองงาน</label>
                  <input type="text" value={form.code} onChange={e => setForm({ ...form, code: e.target.value })} placeholder="เช่น EDU" style={inputStyle} />
                </div>
                <div>
                  <label style={labelStyle}>ระดับ</label>
                  <select value={form.level} onChange={e => setForm({ ...form, level: e.target.value })} style={inputStyle}>
                    <option value="สำนัก">สำนัก</option>
                    <option value="กอง">กอง</option>
                    <option value="ฝ่าย">ฝ่าย</option>
                  </select>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
                <button onClick={() => setShowModal(false)}
                  style={{ flex: 1, padding: '10px', background: 'white', color: '#64748b', border: '0.5px solid #e2e8f0', borderRadius: '10px', fontSize: '13px', cursor: 'pointer' }}>ยกเลิก</button>
                <button onClick={handleSave} disabled={saving}
                  style={{ flex: 1, padding: '10px', background: saving ? '#a5b4fc' : '#075dcc', color: 'white', border: 'none', borderRadius: '10px', fontSize: '13px', fontWeight: '500', cursor: saving ? 'not-allowed' : 'pointer' }}>
                  {saving ? 'กำลังบันทึก...' : 'บันทึก'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Layout>
  )
}
